import { Injectable } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
} from '@spartacus/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';
import { ExcelDownloadService } from '../shared/services/excel-download.service';
import { SharedService } from '../shared/services/shared.service';
@Injectable({
  providedIn: 'root',
})
export class CustomInfluenzaService {
  activeSeaons: any;
  activetab: any;
  fluProducts: any;
  waitList: any;
  influenzaContact: any;
  addedProductsToCart: any;
  addedWaitlist: any;
  userIdOfLoggedInUser: any;
  activeCartId: any;
  fluProductsFromCart: any;
  cartDlete: any;
  itemDlete: any;
  contiueShopping = false;
  updateFluCart: any;
  ordersHistory: any;
  seasonOrderHistory: any;
  cartType: any;
  dataForExcel: any;
  updatedInfContact: any;
  detailedReservation: any;
  cartIdActiveOfUser: any;
  createCartOfUser: any;
  reservationDetails: any;
  reservationDetailsSave: any;
  flulocatorDetailsSave: any;
  flulocatorDetailsSaveForAll: any;
  changedLocation: any;
  removedFluCartItems: any;
  public deliveryHoursAlertBanner = new BehaviorSubject<any>(false);
  deliveryHoursAlertBanner$ = this.deliveryHoursAlertBanner.asObservable();
  public printOverviewPage = new BehaviorSubject<any>(false);
  printOverviewPage$ = this.printOverviewPage.asObservable();
  public checkoutInfluenza = new BehaviorSubject<any>(false);
  checkoutInfluenza$ = this.checkoutInfluenza.asObservable();
  defaultFields = '?fields=DEFAULT';
  getVolumePrices: any;
  activeSeaonPrice: any;
  cartItems: any;
  addedProductsToCartFlu: any;
  addedProductsToCartFluError: any;
  public fluTimerCompletedSubject = new Subject<any>();
  public fluLockTimer: any;
  fluLocatorDetails: any;
  fluLocatorDetailsReservation: any;
  userAccountDetails = new Subject();

  public viewReservationXlsdownload = new Subject<any>();
  public setShippingSchedule = new BehaviorSubject<any>(null);
  public cartDetails = new BehaviorSubject<any>(false);
  public cartDetailsError = new BehaviorSubject<any>(false);
  public loggedInUserDetails = new BehaviorSubject<any>(false);
  public fluOrderActivityDetails = new BehaviorSubject<any>(false);

  public placeOrderResp = new BehaviorSubject<any>(false);

  constructor(
    private readonly baseService: BaseService,
    private readonly router: RoutingService,
    private readonly sharedService: SharedService,
    private readonly globalMessage: GlobalMessageService,
    public excelService: ExcelDownloadService
  ) {
    this.activeSeaons = new Subject();
    this.activetab = new Subject();
    this.fluProducts = new Subject();
    this.waitList = new Subject();
    this.influenzaContact = new Subject();
    this.addedProductsToCart = new Subject();
    this.addedWaitlist = new Subject();
    this.userIdOfLoggedInUser = new Subject();
    this.activeCartId = new Subject();
    this.fluProductsFromCart = new Subject();
    this.cartDlete = new Subject();
    this.itemDlete = new Subject();
    this.reservationDetails = new Subject();
    this.reservationDetailsSave = new Subject();
    this.flulocatorDetailsSave = new Subject();
    this.flulocatorDetailsSaveForAll = new Subject();
    this.updateFluCart = new Subject();
    this.ordersHistory = new Subject();
    this.seasonOrderHistory = new Subject();
    this.updatedInfContact = new Subject();
    this.detailedReservation = new ReplaySubject();
    this.cartIdActiveOfUser = new Subject();
    this.createCartOfUser = new Subject();
    this.changedLocation = new Subject();
    this.removedFluCartItems = new Subject();
    this.getVolumePrices = new Subject();
    this.activeSeaonPrice = new Subject();
    this.cartItems = new Subject();
    this.addedProductsToCartFlu = new Subject();
    this.addedProductsToCartFluError = new Subject();
    this.fluLocatorDetails = new Subject();
    this.fluLocatorDetailsReservation = new Subject();
  }

  public getUserAccountDetailsDataFromDb(userId, accountId): void {
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, {
        fields: 'FULL',
      })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          // this.userAccountdetailsType = res.type;
          this.userAccountDetails.next({ res });
        }
      });
  }

  public removedFluCartEntries(cartId, userId) {
    this.baseService
      .get(
        'users/' +
          userId +
          '/carts/' +
          cartId +
          '?cartPage=true&fields=DEFAULT&standardCart=false'
      )
      .subscribe((res) => {
        if (res) {
          this.removedFluCartItems.next(res);
        }
      });
  }
  public updateShipToId(userId, cartId, shipToUnitId, standardCart) {
    this.baseService
      .post(
        '/users/' +
          userId +
          '/carts/' +
          cartId +
          '/addShipToUnit/' +
          shipToUnitId +
          '/' +
          standardCart +
          this.defaultFields,
        {}
      )
      .subscribe((res) => {
        if (res) {
          this.changedLocation.next(true);
        }
      });
  }

  public getCartIdofUser(userId) {
    this.baseService
      .get(
        '/Influenza/recurring-reservation/' +
          userId +
          '/carts?currentPage=0&fields=DEFAULT&pageSize=20&savedCartsOnly=false'
      )
      .subscribe((res) => {
        if (res) {
          this.cartIdActiveOfUser.next(res);
        }
      });
  }

  public getReservationDetails(b2baccountID) {
    this.baseService
      .get('Influenza/recurring-reservation/view-all/' + b2baccountID + '?')
      .subscribe((res) => {
        if (res) {
          this.reservationDetails.next(res);
        }
      });
  }

  public saveReservationDetails(b2baccountID, param) {
    var req = this.baseService
      .post(
        'Influenza/recurring-reservation/' + b2baccountID + '/save-details?',
        param
      )
      .subscribe((res) => {
        if (res) {
          this.reservationDetailsSave.next(res);
        }
      });
  }

  public saveFluLocatorDetails(userid, param) {
    var req = this.baseService
      .post('users/' + userid + '/locator/updateFluLocationData', param)
      .subscribe((res) => {
        if (res) {
          this.flulocatorDetailsSave.next(res);
        }
      });
  }

  public saveFluLocatorDetailsForAll(userid, param) {
    var req = this.baseService
      .post('users/' + userid + '/locator/updateMultipleFluLocationData', param)
      .subscribe((res) => {
        if (res) {
          this.flulocatorDetailsSaveForAll.next(res);
        }
      });
  }
  public CreateCartIdofUser(userId) {
    this.baseService
      .post('users/' + userId + '/carts?fields=DEFAULT', {})
      .subscribe((res) => {
        if (res) {
          this.createCartOfUser.next(res);
        }
      });
  }
  public getVolumePrice(products) {
    this.baseService
      .post('/products/getPrice?fields=DEFAULT', products)
      .subscribe((res) => {
        if (res) {
          this.getVolumePrices.next(res);
        }
      });
  }

  public getFluOrderActivityDetails(userId, orderId) {
    this.baseService
      .get('flu/influenza-overview/getOrderActivity/' + userId + '/' + orderId)
      .subscribe((res) => {
        if (res) {
          this.fluOrderActivityDetails.next(res);
        }
      });
  }

  public getActiveSeasonsFromDb(userId) {
    this.baseService
      .get('users/' + userId + '/influenza/get-active-seasons?fields=FULL')
      .subscribe((res) => {
        if (res) {
          this.activeSeaons.next(res);
        }
      });
  }

public getActiveSeasonsForFluRes(userId) {
    this.baseService
      .get('users/' + userId + '/influenza/get-active-seasons?fields=BASIC')
      .subscribe((res) => {
        if (res) {
          this.activeSeaons.next(res);
        }
      });
  }
  public getUserOrderHistory(userId, seasonId) {
    this.baseService
      .get(
        'users/' +
          userId +
          '/orders?currentPage=0&fields=DEFAULT&orderType=ZPRE&seasonId=' +
          seasonId
      )
      .subscribe((res) => {
        if (res) {
          this.ordersHistory.next(res);
        }
      });
  }
  public getUserSeasonWiseOrders(userId, seasonId) {
    this.baseService
      .get(
        'users/' +
          userId +
          '/influenza/getSeasonOrders/' +
          seasonId +
          this.defaultFields
      )
      .subscribe((res) => {
        if (res) {
          this.seasonOrderHistory.next(res);
        }
      });
  }
  public getFluProducts(userId, seasonId) {
    this.fluProducts.next(false);
    //this.baseService.get('users/' + userId + '/influenza/get-fluproducts-by-seasonId/' + seasonId).subscribe((res) => {
    this.baseService
      .get('flu/create-reservation/select-vaccines/' + seasonId)
      .subscribe((res) => {
        if (res) {
          this.fluProducts.next(res);
        }
      });
  }
  //Created for forkjoin use
  public getFluProductsV2(userId, seasonId) {
    return this.baseService.get(
      'flu/create-reservation/select-vaccines/' + seasonId
    );
  }
  public getWaitListDetails(userId, b2bUnitId) {
    this.baseService
      .get('users/' + userId + '/' + b2bUnitId + '/waitlist/getWaitlistDetails')
      .subscribe((res) => {
        if (res) {
          this.waitList.next(res);
        }
      });
  }
  public getReserveContactDetails(userId, b2bUnitId) {
    return this.baseService.get(
      'users/' + userId + '/' + b2bUnitId + '/waitlist/getWaitlistDetails'
    );
    // .subscribe((res) => {
    //   if (res) {
    //     this.waitList.next(res);
    //   }
    // });
  }
  public saveWaitList(userId, b2bUnitId, params) {
    // this.baseService.get('users/' + userId + '/waitlist/getWaitlistDetails').subscribe((res) => {
    //   if (res) {
    //     this.waitList.next(res);
    //   }
    // });

    this.baseService
      .post('users/' + userId + '/' + b2bUnitId + '/waitlist/save', params)
      .subscribe(
        (res) => {
          if (res) {
            this.addedWaitlist.next(res);
          }
        },
        (err) => {
          this.addedWaitlist.next(err);
        }
      );
  }
  public getFluOrderContact(userId) {
    this.baseService.get('users/' + userId + '/b2bUnits').subscribe((res) => {
      if (res) {
        this.influenzaContact.next(res);
      }
    });
  }
  public downloadInvoicePdf(invoiceNo) {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_PDF, { invoiceNumber: invoiceNo })
      .subscribe(
        (res) => {
          if (res.size > 0) {
            const file = new Blob([res], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            this.globalMessage.add(
              'Requested document is not available at this moment',
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
        },
        (error) => {
          this.globalMessage.add(
            'Requested document is not available at this moment',
            GlobalMessageType.MSG_TYPE_ERROR
          );
        }
      );
  }
  public getDetailedReservation(userId, orderId, boolean) {
    this.baseService
      .get('users/' + userId + '/orders/' + orderId + this.defaultFields)
      .subscribe((res) => {
        if (res) {
          sessionStorage.removeItem('fluOverviewData');
          this.sharedService.setSessionStorage('fluOverviewData', res);

          this.detailedReservation.next(res);
          if (boolean) {
            this.router.goByUrl('/influenza/reservation-overview');
          }
        }
      });
  }
  public getFluProductsFromCart(userId, cartId, page) {
    if (cartId) {
      this.baseService
        .get('users/' + userId + '/carts/' + cartId + this.defaultFields)
        .subscribe((res) => {
          if (res) {
            this.fluProductsFromCart.next(res);
          }
        });
    }
  }

  public addFluProductsToCart(userId, cartId, params) {
    this.baseService
      .post(
        'users/' + userId + '/carts/' + cartId + '/bulk-add-to-cart',
        params
      )
      .subscribe(
        (res) => {
          if (res) {
            this.addedProductsToCart.next(res);
          }
        },
        (err) => {
          this.addedProductsToCart.next(err);
        }
      );
  }
  public updateFluProductsToCart(userId, parentCartId, childCartId, params) {
    this.baseService
      .patch(
        'users/' +
          userId +
          '/carts/' +
          parentCartId +
          '/update/' +
          childCartId +
          this.defaultFields,
        params
      )
      .subscribe(
        (res) => {
          if (res) {
            this.updateFluCart.next(res);
          }
        },
        (err) => {
          this.updateFluCart.next(err);
        }
      );
  }
  public deleteEntireCart(userId, childCartId) {
    this.baseService
      .delete('users/' + userId + '/carts/' + childCartId)
      .subscribe((res) => {
        this.cartDlete.next(true);
      });
  }
  public deleteCartItems(userId, parentCartId, entryNumber, childCartId) {
    this.baseService
      .delete(
        'users/' +
          userId +
          '/carts/' +
          parentCartId +
          '/entries/' +
          entryNumber +
          '/' +
          childCartId
      )
      .subscribe((res) => {
        this.itemDlete.next(true);
      });
  }
  public downloadXls(data, name) {
    this.excelService.exportAsExcelFile(data, name, true);
  }
  public downloadXlsFixWidthWrapText(data, name, noOfColumns) {
    this.excelService.exportAsExcelFileFixWidthWrapText(
      data,
      name,
      noOfColumns,
      true
    );
  }

  public checkoutItems(userId, cartId, params) {
    this.checkoutInfluenza.next(false);
    this.baseService
      .post(
        'users/' +
          userId +
          '/carts/' +
          cartId +
          '/orderSimulate?fields=DEFAULT',
        params
      )
      .subscribe(
        (res) => {
          if (res) {
            this.checkoutInfluenza.next(res);
          }
        },
        (err) => {
          this.checkoutInfluenza.next(err);
        }
      );
  }
  updateContact(params, userId): void {
    this.baseService
      .put('users/' + userId + '/influenza/updateContactInfo', params)
      .subscribe((res) => {
        if (res) {
          this.updatedInfContact.next(res);
        }
      });
  }

  public getActiveSeasonPrice(userId, seasonId) {
    this.baseService
      .get('users/' + userId + '/influenza/get-seasons-price/' + seasonId)
      .subscribe((res) => {
        if (res) {
          this.activeSeaonPrice.next(res);
        }
      });
  }

  //Creted for forkjoin use
  public getActiveSeasonPriceV2(userId, seasonId) {
    return this.baseService.get(
      'users/' + userId + '/influenza/get-seasons-price/' + seasonId
    );
  }

  public getCarts(userId) {
    this.baseService
      .get(
        config.USER_ACCOUNT +
          userId +
          '/carts?currentPage=0&fields=DEFAULT&pageSize=20&savedCartsOnly=false&standardCart=false'
      )
      .subscribe((res) => {
        this.cartItems.next(res);
      });
  }
  public addProdToCartFlu(userId, cartId, params) {
    this.baseService
      .post(
        config.USER_ACCOUNT +
          userId +
          '/carts/' +
          cartId +
          '/entries?fields=DEFAULT&updateQuantity=true',
        params
      )
      .subscribe(
        (res) => {
          if (res) {
            this.addedProductsToCartFlu.next(res);
          }
        },
        (err) => {
          this.addedProductsToCartFluError.next(err);
        }
      );
  }

  updateCartDetails(userId, childCartId, entries, cartId): void {
    this.cartDetails = new BehaviorSubject<any>(false);
    this.cartDetailsError = new BehaviorSubject<any>(false);
    this.baseService
      .patch(
        `${config.USER_ACCOUNT}${userId}/carts/${cartId}/update/${childCartId}?fields=DEFAULT`,
        entries
      )
      .subscribe(
        (res) => {
          if (res) {
            this.cartDetails.next(res);
          }
        },
        (err) => {
          this.cartDetailsError.next(err);
        }
      );
  }

  cartCheck(cartId, userId, params) {
    return this.baseService.post(
      `/user/${userId}/checkcart/${cartId}?fields=FULL`,
      params
    );
  }

  cartCheckout(parentCartId, userId, params) {
    return this.baseService.post(
      `/user/${userId}/checkout/${parentCartId}?fields=FULL`,
      params
    );
  }

  getEditCancelReductionReasons(params) {
    return this.baseService.get(config.GET_PRACTICEORFACILITYTYPE, params);
  }

  getOrderDetailsForEditReservation(orderNo, userId) {
    return this.baseService.post(
      `/user/${userId}/checkcart/order/${orderNo}?fields=FULL`,
      {}
    );
  }
  getEstimatedTotal(userId, parentCartId, params) {
    return this.baseService.post(
      `/user/${userId}/checkcartprice/${parentCartId}`,
      params
    );
  }
  getDeliveryDates(userId, parentCartId, params) {
    return this.baseService.post(
      `/user/${userId}/checkcartdates/${parentCartId}`,
      params
    );
  }

  public fluLockOrUnlock(userId, params) {
    return this.baseService.post(
      'user/' + userId + '/flulock' + this.defaultFields,
      params
    );
  }

  public startFluJourneyTimer(duration: number) {
    this.fluLockTimer = setTimeout(() => {
      this.fluTimerCompletedSubject.next(true);
    }, duration);
  }

  public extendFluJourneyTimer(duration: number) {
    clearTimeout(this.fluLockTimer);
    this.startFluJourneyTimer(duration);
  }

  public endFluJourneyTimer() {
    clearTimeout(this.fluLockTimer);
  }

  public getFluLocatorDetails(userId, b2bUnitID, params?) {
    this.baseService
      .get('users/' + userId + '/locator/flu-locator/' + b2bUnitID, params)
      .subscribe((res) => {
        if (res) {
          this.fluLocatorDetails.next(res);
        }
      });
  }

  public getFluLocatorDetailsReservation(userId, params, reservationId) {
    this.baseService
      .get(
        'users/' +
          userId +
          '/locator/createFluLocationData/' +
          params +
          '/' +
          reservationId
      )
      .subscribe((res) => {
        if (res) {
          this.fluLocatorDetailsReservation.next(res);
        }
      });
  }

  //STS specific create reservation apis
  public getStsShippingMainSectionData(userId, cartId, seasonId, b2bUnitId) {
    return this.baseService.get(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/create-reservation/stsAdmin/${seasonId}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`
    );
  }
  public getStsShippingCalendarSectionData(
    userId,
    cartId,
    seasonId,
    b2bUnitId
  ) {
    return this.baseService.get(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/create-reservation/getSTS/${seasonId}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`
    );
  }
  public updateStsFrequencyCalendarSectionData(
    userId,
    cartId,
    seasonId,
    b2bUnitId,
    requestObj
  ) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/create-reservation/frequency-update/${seasonId}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`,
      requestObj
    );
  }
  public saveStsOrder(userId, cartId, seasonId, b2bUnitId, requestObj) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/create-reservation/save-order/${seasonId}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`,
      requestObj
    );
  }

  //STS specific apis for edit reservation
  public getOrderStsShippingMainSectionData(
    userId,
    cartId,
    seasonId,
    b2bUnitId,
    orderNo
  ) {
    return this.baseService.get(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/edit-reservation/stsAdmin/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`
    );
  }
  public getOrderStsShippingCalendarSectionData(
    userId,
    cartId,
    seasonId,
    b2bUnitId,
    orderNo
  ) {
    return this.baseService.get(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/edit-reservation/getSTS/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`
    );
  }
  public updateOrderStsFrequencyCalendarSectionData(
    userId,
    cartId,
    seasonId,
    b2bUnitId,
    requestObj,
    orderNo
  ) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/edit-reservation/frequency-update/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`,
      requestObj
    );
  }
  public updateStsOrder(
    userId,
    cartId,
    seasonId,
    b2bUnitId,
    requestObj,
    orderNo
  ) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userId}/carts/${cartId}/flu/edit-reservation/save-order/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`,
      requestObj
    );
  }

  //STS specific apis for view reservation
  public viewOrderStsShippingMainSectionData(seasonId, b2bUnitId, orderNo) {
    return this.baseService.get(
      `/flu/influenza-overview/stsAdmin/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`
    );
  }
  public viewOrderStsShippingCalendarSectionData(seasonId, b2bUnitId, orderNo) {
    return this.baseService.get(
      `/flu/influenza-overview/shippingSchedule/${b2bUnitId}/${orderNo}?season=${seasonId}&fields=DEFAULT`
    );
  }
  public changeOrderStsFrequencyCalendarSectionData(
    seasonId,
    b2bUnitId,
    requestObj,
    orderNo
  ) {
    return this.baseService.post(
      `/flu/influenza-overview/frequency-update/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`,
      requestObj
    );
  }
  public changeStsOrder(seasonId, b2bUnitId, requestObj, orderNo) {
    return this.baseService.post(
      `/flu/influenza-overview/sts/save-order/${seasonId}/${orderNo}?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`,
      requestObj
    );
  }
  createOrdermethod(cartId, userId, params) {
    this.placeOrderResp.next(false);
    return this.baseService
      .post(
        `${config.USER_ACCOUNT}${userId}/place-order?cartId=${cartId}&fields=DEFAULT`,
        params
      )
      .subscribe((res) => {
        this.placeOrderResp.next(res);
      });
  }

  editOrdermethod(cartId, userId, params) {
    this.placeOrderResp.next(false);
    return this.baseService
      .post(
        `${config.USER_ACCOUNT}${userId}/edit-order?cartId=${cartId}&fields=DEFAULT`,
        params
      )
      .subscribe((res) => {
        this.placeOrderResp.next(res);
      });
  }
}
